import { render, staticRenderFns } from "./EditarRelatorio.vue?vue&type=template&id=513a44d4&lang=pug"
import script from "./EditarRelatorio.vue?vue&type=script&lang=js"
export * from "./EditarRelatorio.vue?vue&type=script&lang=js"
import style0 from "./EditarRelatorio.vue?vue&type=style&index=0&id=513a44d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports